import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取销售明细列表
 * @param {Object} params 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function getSalesInfoList(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/mallReport/getSalesInfo',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}